export default __webpack_public_path__ + "static/media/Footer_GetHelp@2x.835ce452.png";